import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import styled from 'styled-components';

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin-bottom: 0.65rem;
`;

const RowLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.65rem;
  text-decoration: none;
  color: inherit;

  &:hover {
    opacity: 0.92;
  }
`;

const Logo = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-weight: 700;
  border: 2px solid #e2e8f0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const ShopName = styled.span`
  font-size: 0.98rem;
  font-weight: 700;
  color: var(--text-primary, #0f172a);
`;

const ShopIdentityRow = ({ name, logoUrl, to }) => {
  const shopName = (name || '').trim();
  if (!shopName && !logoUrl) {
    return null;
  }

  const initial = (shopName || '?').charAt(0).toUpperCase();
  const content = (
    <>
      <Logo>
        {logoUrl ? <img src={logoUrl} alt="" /> : initial}
      </Logo>
      {shopName ? <ShopName>{shopName}</ShopName> : null}
    </>
  );

  if (to) {
    return (
      <Row>
        <RowLink to={to} aria-label={shopName ? `Open ${shopName} shop` : 'Open shop'}>
          {content}
        </RowLink>
      </Row>
    );
  }

  return <Row>{content}</Row>;
};

ShopIdentityRow.propTypes = {
  name: PropTypes.string,
  logoUrl: PropTypes.string,
  to: PropTypes.string,
};

export default ShopIdentityRow;
